import sdkFactory from '@yandex-data-ui/sdk';
import {getCSRFToken} from 'utils';
import Schema from '../common/schema';

const sdkConfig = {
    csrfToken: getCSRFToken(),
    endpoint: '/gateway',
};

const sdk = sdkFactory<typeof Schema>(sdkConfig);

export default sdk;
